export const SkillsProgramming = [
  "_React",
  "_React Native",
  "_Redux",
  "_Javascript",
  "_Typescript",
  "_Next",
  "_API REST | Axios",
  "_HTML",
  "_SCSS",
  "_Figma",
  "_Material UI | Tailwind",
  "_GraphQL",
  "_Git | GitHub",
  "_Agile methodologies",
  "_Linux",
  "_XML - JSON",
];